var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 17.5V13.3333C13 13.1123 12.9122 12.9004 12.7559 12.7441C12.5996 12.5878 12.3877 12.5 12.1667 12.5H8.83333C8.61232 12.5 8.40036 12.5878 8.24408 12.7441C8.0878 12.9004 8 13.1123 8 13.3333V17.5",
    stroke: "#F4FDFA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3118 8.5915C15.1381 8.4252 14.9069 8.33237 14.6664 8.33237C14.4259 8.33237 14.1947 8.4252 14.021 8.5915C13.6335 8.9611 13.1185 9.1673 12.583 9.1673C12.0475 9.1673 11.5326 8.9611 11.1451 8.5915C10.9714 8.42545 10.7404 8.33277 10.5001 8.33277C10.2598 8.33277 10.0288 8.42545 9.85512 8.5915C9.46759 8.96135 8.95248 9.1677 8.41679 9.1677C7.8811 9.1677 7.36599 8.96135 6.97846 8.5915C6.80474 8.4252 6.57353 8.33237 6.33304 8.33237C6.09255 8.33237 5.86134 8.4252 5.68762 8.5915C5.31333 8.94868 4.81952 9.15381 4.30231 9.16696C3.78511 9.18011 3.28151 9.00035 2.88954 8.66265C2.49758 8.32496 2.24529 7.8535 2.18178 7.34004C2.11827 6.82658 2.24808 6.30786 2.54596 5.88484L4.95346 2.39817C5.10621 2.17276 5.31187 1.98822 5.55244 1.86067C5.79301 1.73312 6.06117 1.66645 6.33346 1.6665H14.6668C14.9383 1.6664 15.2057 1.73262 15.4458 1.85941C15.6858 1.9862 15.8913 2.16972 16.0443 2.394L18.4568 5.88734C18.7547 6.31069 18.8844 6.82981 18.8205 7.34354C18.7566 7.85726 18.5037 8.32879 18.1111 8.66625C17.7185 9.0037 17.2144 9.1829 16.6969 9.16893C16.1794 9.15496 15.6856 8.94881 15.3118 8.59067",
    stroke: "#F4FDFA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.83398 9.125V15.8333C3.83398 16.2754 4.00958 16.6993 4.32214 17.0118C4.6347 17.3244 5.05862 17.5 5.50065 17.5H15.5006C15.9427 17.5 16.3666 17.3244 16.6792 17.0118C16.9917 16.6993 17.1673 16.2754 17.1673 15.8333V9.125",
    stroke: "#F4FDFA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStore);
export default __webpack_public_path__ + "static/media/store.864fb5d4badb6e0a524c7fb960f30476.svg";
export { ForwardRef as ReactComponent };